<mat-card>
  <h2 [translate]="!interviniente ? 'holderData.title' : 'intervinentData.Title'">
    {{ (!interviniente ? 'holderData.title' : 'intervinentData.Title') | translate }} {{ numInterviniente }}
  </h2>
  <form [formGroup]="holderDataForm">
    <div fxFlex fxLayout="row wrap" class="form-wrapper">
      <div fxFlex="50" fxFlex.gt-sm="20" *ngIf="interviniente">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="holderAccount"
          [id]="'holderAccountHolder' + (interviniente ? numInterviniente : '')"
          [dataInput]="holderAccountList"
          [placeholder]="'intervinentData.type'"
          [isRequired]="true"
          [hasToTranslateValue]="true"
          [showErrors]="holderDataForm?.controls?.holderAccount?.errors"
          (selectionChange)="onChangeHolderAccount($event)"
        ></scf-custom-select-search>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="20" *ngIf="interviniente">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="relationHolder"
          [id]="'relationHolder' + (interviniente ? numInterviniente : '')"
          [dataInput]="relationHolderList"
          [placeholder]="'intervinentData.relation'"
          [isRequired]="true"
          [showErrors]="holderDataForm?.controls?.relationHolder?.errors"
        ></scf-custom-select-search>
      </div>
      <div fxFlex="50" [fxFlex.gt-sm]="interviniente ? 20 : 25">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="gender"
          [id]="'genderHolder' + (interviniente ? numInterviniente : '')"
          [dataInput]="genderList"
          [placeholder]="'holderData.gender'"
          [isRequired]="true"
          [hasToTranslateValue]="true"
          [showErrors]="holderDataForm?.controls?.gender?.errors"
        ></scf-custom-select-search>
      </div>
      <div fxFlex="50" [fxFlex.gt-sm]="interviniente ? 20 : 25">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>holderData.nifNie</mat-label>
          <input
            [id]="'nifNieHolder' + (interviniente ? numInterviniente : '')"
            formControlName="nifNie"
            matInput
            type="text"
            maxlength="10"
            (blur)="addNacionality()"
            (change)="validateDuplicatedDni()"
            autocomplete="off"
          />
          <mat-error *ngIf="holderDataForm.controls.nifNie.hasError('required')" translate> field.required </mat-error>
          <mat-error
            *ngIf="holderDataForm.controls.nifNie.invalid && !holderDataForm.controls.nifNie.hasError('required')"
            translate
          >
            field.error.nif
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="50" [fxFlex.gt-sm]="interviniente ? 20 : 25">
        <mat-form-field monthYearDayDirective fxFlex="100" appearance="outline">
          <mat-label translate>holderData.nifNieExpiration</mat-label>
          <input
            [id]="'nifNieExpirationHolder' + (interviniente ? numInterviniente : '')"
            formControlName="nifNieExpiration"
            matInput
            maxlength="10"
            [min]="minDateNif"
            [max]="maxDateNif"
            [matDatepicker]="datepickerNif"
            autocomplete="off"
          />
          <mat-datepicker-toggle matSuffix [for]="datepickerNif"></mat-datepicker-toggle>
          <mat-datepicker #datepickerNif></mat-datepicker>
          <mat-error
            *ngIf="
              holderDataForm.controls.nifNieExpiration.hasError('required') &&
              !holderDataForm.controls.nifNieExpiration.hasError('matDatepickerParse')
            "
            translate
          >
            field.required
          </mat-error>
          <mat-error *ngIf="holderDataForm.controls.nifNieExpiration.hasError('matDatepickerMax')" translate>
            field.error.maxDate
          </mat-error>
          <mat-error *ngIf="holderDataForm.controls.nifNieExpiration.hasError('matDatepickerMin')" translate>
            field.error.minDateToCurrent
          </mat-error>
          <mat-error *ngIf="holderDataForm.controls.nifNieExpiration.hasError('matDatepickerParse')" translate>
            field.error.parseDate
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="0" fxFlex.gt-sm="25" *ngIf="!interviniente"></div>

      <div fxFlex="50" fxFlex.gt-sm="25">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>holderData.name</mat-label>
          <input
            [id]="'nameHolder' + (interviniente ? numInterviniente : '')"
            #nameHolder
            formControlName="name"
            matInput
            type="text"
            maxlength="30"
            (keypress)="lettersOnly($event)"
            (paste)="lettersOnly($event)"
            autocomplete="off"
          />
          <!-- (blur)="checkNameAndSurname($event, nameHolder)" CTI-->
          <mat-error *ngIf="holderDataForm.controls.name.hasError('required')" translate> field.required </mat-error>
          <mat-error *ngIf="holderDataForm.controls.name.hasError('incorrect')" translate> field.incorrect </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="25">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>holderData.surname1</mat-label>
          <input
            [id]="'surname1Holder' + (interviniente ? numInterviniente : '')"
            #surname1Holder
            formControlName="surname1"
            matInput
            type="text"
            maxlength="30"
            (keypress)="lettersOnly($event)"
            (paste)="lettersOnly($event)"
            autocomplete="off"
          />
          <!-- (blur)="checkNameAndSurname($event, surname1Holder)" CTI-->
          <mat-error *ngIf="holderDataForm.controls.surname1.hasError('required')" translate>
            field.required
          </mat-error>
          <mat-error *ngIf="holderDataForm.controls.surname1.hasError('incorrect')" translate>
            field.incorrect
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="25">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>holderData.surname2</mat-label>
          <input
            [id]="'surname2Holder' + (interviniente ? numInterviniente : '')"
            #surname2Holder
            formControlName="surname2"
            matInput
            type="text"
            maxlength="30"
            (keypress)="lettersOnly($event)"
            (paste)="lettersOnly($event)"
            autocomplete="off"
          />
          <!-- (blur)="checkNameAndSurname($event, surname2Holder)" CTI-->
          <mat-error *ngIf="holderDataForm.controls.surname2.hasError('required')" translate>
            field.required
          </mat-error>
          <mat-error *ngIf="holderDataForm.controls.surname2.hasError('incorrect')" translate>
            field.incorrect
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="25">
        <mat-form-field monthYearDayDirective fxFlex="100" appearance="outline">
          <mat-label translate>holderData.birthDate</mat-label>
          <input
            [id]="'birthDateHolder' + (interviniente ? numInterviniente : '')"
            matInput
            maxlength="10"
            formControlName="birthDate"
            [min]="minDateBirthday"
            [max]="maxDateBirthday"
            [matDatepicker]="datepickerbirth"
            autocomplete="off"
          />
          <mat-datepicker-toggle matSuffix [for]="datepickerbirth"></mat-datepicker-toggle>
          <mat-datepicker #datepickerbirth></mat-datepicker>
          <mat-error
            *ngIf="
              holderDataForm.controls.birthDate.hasError('required') &&
              !holderDataForm.controls.birthDate.hasError('matDatepickerParse')
            "
            translate
          >
            field.required
          </mat-error>
          <mat-error *ngIf="holderDataForm.controls.birthDate.hasError('matDatepickerMax')" translate>
            field.error.maxDateToCurrent
          </mat-error>
          <mat-error *ngIf="holderDataForm.controls.birthDate.hasError('matDatepickerMin')" translate>
            field.error.minDate
          </mat-error>
          <mat-error *ngIf="holderDataForm.controls.birthDate.hasError('matDatepickerParse')" translate>
            field.error.parseDate
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="25">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="nationality"
          [id]="'nationalityHolder' + (interviniente ? numInterviniente : '')"
          [dataInput]="countryList"
          [placeholder]="'holderData.nacionality'"
          [isRequired]="true"
          [showErrors]="holderDataForm?.controls?.nationality?.errors"
          (selectionChange)="onChangeNacionalityHolder($event.value)"
        ></scf-custom-select-search>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="25">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="birthCountry"
          [id]="'birthCountryHolder' + (interviniente ? numInterviniente : '')"
          [dataInput]="countryList"
          [placeholder]="'holderData.birthCountry'"
          [isRequired]="true"
          [showErrors]="holderDataForm?.controls?.birthCountry?.errors"
        ></scf-custom-select-search>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="25">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="civilStatus"
          [id]="'civilStatusHolder' + (interviniente ? numInterviniente : '')"
          [dataInput]="civilStatusList"
          [placeholder]="'holderData.civilStatus'"
          [isRequired]="true"
          [showErrors]="holderDataForm?.controls?.civilStatus?.errors"
        ></scf-custom-select-search>
      </div>
      <div *ngIf="showVideoSelfing" fxFlex="50" fxFlex.gt-sm="25">
        <div class="videoSelfing_checkbox">
          <input
            color="accent"
            type="checkbox"
            [id]="'checkVideoSelfing' + (interviniente ? numInterviniente : '')"
            name="checkVideoSelfing"
            [(ngModel)]="checked"
            formControlName="checkVideoSelfing"
            (change)="setVideoSelfingChange()"
            autocomplete="off"
          />
          <span translate>resquest.videoselfing</span>
        </div>
      </div>
    </div>
  </form>
</mat-card>
